module.exports = __webpack_public_path__ + "img/serive4.6876ebd6.jpg";